var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-notification",class:_vm.classes},[_c('div',{staticClass:"view-notification-content"},[_c('fade',[(_vm.message)?_c('div',{key:_vm.key},[_c('div',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',[_c('click-button',{attrs:{"callback":_vm.close}},[_vm._v("Close")])],1)]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58ca7d12","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Notification.vue
// module id = 308
// module chunks = 0